import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58dc8450"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "plan-card__badge"
}
const _hoisted_2 = { class: "plan-card__content" }
const _hoisted_3 = { class: "plan-card__title" }
const _hoisted_4 = { class: "plan-card__price-text" }
const _hoisted_5 = { class: "plan-card__price" }
const _hoisted_6 = {
  key: 0,
  class: "plan-card__price-old"
}

import { PlanView, BillingView } from '@/models/billing'
import { PlanPrice } from '@/models/billing.plans'
import { computed } from 'vue'
import TrialBadge from './TrialBadge.vue'
import { trialByPlan15535Treatment } from '@/services/ab/15535_trial_by_plan'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlanCard',
  props: {
    variant: null,
    plan: null,
    billing: null,
    selected: { type: Boolean },
    savings: null,
    newPrice: null,
    oldPrice: null
  },
  setup(__props: any) {

const props = __props as {
  variant: 'annual' | 'monthly'
  plan: PlanView
  billing: BillingView
  selected: boolean
  savings?: number
  newPrice: PlanPrice
  oldPrice?: PlanPrice
};



const trialLength = computed(() => {
  return props.billing.trialLength(props.variant)
})

function getPrice(price: PlanPrice): string {
  if (props.variant === 'annual' && props.billing.platform === 'android') {
    // On Android we can't show the annual plan's price per month due to
    // the Play Store rules.
    return price.withPeriod.perYear
  }

  return price.withPeriod.perMonth
}

const savingPercentage = computed(() => {
  if (!props.savings) {
    return null
  }
  if (props.plan.discount?.type === 'percentage') {
    return `${props.plan.discount.value}%`
  }
  return `${props.savings}%`
})

const billedAtText = computed(() => {
  if (
    props.plan.nickname === 'Monthly' ||
    props.billing.platform === 'android'
  ) {
    return `Billed ${props.plan.labels.frequency}`
  }
  return `Billed ${props.plan.labels.frequency} at ${props.plan.price.perPeriod}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["plan-card", { 'plan-card__selected': __props.selected }])
  }, [
    (_unref(savingPercentage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Most Popular • Save " + _toDisplayString(_unref(savingPercentage)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.variant === 'annual' ? 'Annual' : 'Monthly'), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(billedAtText)), 1),
        (!__props.billing.isTrialOver && _unref(trialByPlan15535Treatment)())
          ? (_openBlock(), _createBlock(TrialBadge, {
              key: 0,
              class: "plan-card__trial-badge",
              days: _unref(trialLength)
            }, null, 8, ["days"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass({ 'plan-card__price-new': __props.variant === 'annual' })
        }, _toDisplayString(getPrice(__props.newPrice)), 3),
        (__props.variant === 'annual' && __props.oldPrice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(getPrice(__props.oldPrice)), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})